import { render, staticRenderFns } from "./Memcon.vue?vue&type=template&id=5bfe19c0"
import script from "./Memcon.vue?vue&type=script&lang=js"
export * from "./Memcon.vue?vue&type=script&lang=js"
import style0 from "./Memcon.vue?vue&type=style&index=0&id=5bfe19c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports